import { reactive, computed } from 'vue';

const state = reactive({
  isLoading: false,
  showTimerId: null,
  hideTimerId: null,
  pendingRequests: 0
});

const startLoading = () => {
  state.pendingRequests += 1;

  // A new request arrived: do not hide loader yet.
  if (state.hideTimerId) {
    clearTimeout(state.hideTimerId);
    state.hideTimerId = null;
  }

  // If loader already visible, keep it visible.
  if (state.isLoading) return;

  // Delay showing slightly to avoid flashing for very fast requests.
  if (!state.showTimerId) {
    state.showTimerId = setTimeout(() => {
      if (state.pendingRequests > 0) {
        state.isLoading = true;
      }
      state.showTimerId = null;
    }, 120);
  }
};

const stopLoading = () => {
  state.pendingRequests = Math.max(0, state.pendingRequests - 1);

  if (state.pendingRequests > 0) return;

  // If loader has not shown yet, cancel pending show.
  if (state.showTimerId) {
    clearTimeout(state.showTimerId);
    state.showTimerId = null;
  }

  // Grace period keeps loader stable across back-to-back requests.
  if (!state.hideTimerId) {
    state.hideTimerId = setTimeout(() => {
      if (state.pendingRequests === 0) {
        state.isLoading = false;
      }
      state.hideTimerId = null;
    }, 350);
  }
};

// Backward compatibility for existing callers.
const setLoading = (loading) => {
  if (loading) {
    startLoading();
    return;
  }
  stopLoading();
};

export default {
  isLoading: computed(() => state.isLoading),
  startLoading,
  stopLoading,
  setLoading
};
